"use strict";
// Shared access request types used by both Ticket and RecurringTask.
// Moved from Trackly.WebClient/src/types/shared/accessRequestTypes.ts (T011) — that file now
// re-exports these from @trackly/shared so existing WebClient importers are unaffected.
Object.defineProperty(exports, "__esModule", { value: true });
exports.hstEmailError = exports.hstUserIdError = exports.hstProvisioningDisplayStatus = exports.HST_PROVISIONING_STATUS_LABELS = void 0;
exports.HST_PROVISIONING_STATUS_LABELS = {
    Pending: 'Pending',
    Provisioned: 'Provisioned',
    Failed: 'Provisioning failed',
    ManualProvisioningNeeded: 'Manual provisioning needed',
};
// A ticket in one of these statuses will not be provisioned any more, so an empty result is not "Pending".
// The API sends the status code (TicketStatus.Value); the names are accepted too.
const HST_FINISHED_TICKET_STATUSES = ['RESV', 'CLSD', 'CANC', 'Resolved', 'Closed', 'Cancelled'];
/** FR-016: the status to show for an HST access request, or `null` to show nothing. The caller
 * decides whether the HstProvisioning flag is on. */
function hstProvisioningDisplayStatus(request, ticketStatus) {
    if (!request)
        return null;
    if (request.provisioning)
        return request.provisioning.status;
    return HST_FINISHED_TICKET_STATUSES.includes(ticketStatus !== null && ticketStatus !== void 0 ? ticketStatus : '') ? null : 'Pending';
}
exports.hstProvisioningDisplayStatus = hstProvisioningDisplayStatus;
const HST_USER_ID_MAX_LENGTH = 50;
const HST_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** FR-004: the HST user ID must be non-empty, without spaces, and at most 50 characters. Checks
 * the value as saved; trimming is used only to detect blank input. */
function hstUserIdError(value) {
    const raw = value !== null && value !== void 0 ? value : '';
    if (!raw.trim())
        return 'Enter the HST user ID. HST needs it to create the login.';
    if (/\s/.test(raw))
        return 'The HST user ID cannot contain spaces.';
    if (raw.length > HST_USER_ID_MAX_LENGTH)
        return `The HST user ID can have at most ${HST_USER_ID_MAX_LENGTH} characters.`;
    return undefined;
}
exports.hstUserIdError = hstUserIdError;
/** FR-004: the email must have the form name@domain.tld, checked as saved. */
function hstEmailError(value) {
    const raw = value !== null && value !== void 0 ? value : '';
    if (!raw.trim())
        return 'Enter an email. HST needs it to create the login.';
    if (!HST_EMAIL_PATTERN.test(raw))
        return 'Enter an email in the form name@domain.com.';
    return undefined;
}
exports.hstEmailError = hstEmailError;
